import { render, staticRenderFns } from "./HandleCountry.vue?vue&type=template&id=56cf8492"
import script from "./HandleCountry.vue?vue&type=script&lang=js"
export * from "./HandleCountry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports